/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Fcquestion1Inputs */

const zh_landing_admin_fcquestion1 = /** @type {(inputs: Landing_Admin_Fcquestion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`细胞的能量工厂是什么？`)
};

const en_landing_admin_fcquestion1 = /** @type {(inputs: Landing_Admin_Fcquestion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the powerhouse of the cell?`)
};

const es_landing_admin_fcquestion1 = /** @type {(inputs: Landing_Admin_Fcquestion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la central energética de la célula?`)
};

/**
* | output |
* | --- |
* | "What is the powerhouse of the cell?" |
*
* @param {Landing_Admin_Fcquestion1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_fcquestion1 = /** @type {((inputs?: Landing_Admin_Fcquestion1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Fcquestion1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_fcquestion1(inputs)
	if (locale === "en") return en_landing_admin_fcquestion1(inputs)
	return es_landing_admin_fcquestion1(inputs)
});
export { landing_admin_fcquestion1 as "landing_admin_fcQuestion" }